import React from 'react'
import { Icon, Menu, MenuButton, MenuList, MenuItem } from '@chakra-ui/react'

export default function SimpleMenu ({ menuProps, buttonProps, trigger, items }) {
  function handleClick (item) {
    item.onClick()
  }

  return (
    <Menu {...menuProps}>
      <MenuButton>{trigger}</MenuButton>
      <MenuList>
        {items?.filter(i => i)?.map((item, i) => (
          <MenuItem key={i} onClick={() => handleClick(item)}>
            {item.icon && <Icon as={item.icon} mr={2} />}
            {item.text}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  )
}
